import React from 'react'
import ButtonExportExcel from '../../../../components/ui/ButtonExportExcel'
import { exportExcelService } from '../../../../service/ExportExcelAdmin'

export default function ExportExcel() {
  const handleClick = async () => {
    try {
      const res = await exportExcelService.export()

      if (!res.status) {
        console.error('Không fetch được API', res.status)
        return
      }

      // Dữ liệu blob đã nằm trong res.data
      const blob = res.data

      const url = window.URL.createObjectURL(blob)

      const a = document.createElement('a')
      a.href = url
      const now = new Date()

      const day = String(now.getDate()).padStart(2, '0')
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const year = now.getFullYear()
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')

      const formatted = `${day}${month}${year}${hours}${minutes}${seconds}`
      a.download = `admin_${formatted}.xlsx`
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Error downloading Excel:', error)
    }
  }

  return <ButtonExportExcel onClick={handleClick} />
}
